export interface IProblemDetailsError {
  data: {
    stack_trace_ui: {
      code: string;
      message: string;
      source: string;
      stack_trace: string;
      status: number;
      type: string;
    };
    exception: {
      message: string;
      stackTrace: string;
    };
    time: string;
    traceId: string;
  };
  detail: string;
  instance: string;
  status: number;
  title: string;
  type: string;
  code?: string;
}

export interface DataProviderFetchError {
  name?: 'FetchError' | 'NotAuthorizedError';
  data?: any;
  errors?: any[];
  status?: number;
  title?: string;
  code?: any;
  responseJSON?: IProblemDetailsError;
}

export const getNativeResponseError = async (
  e: DataProviderFetchError,
): Promise<Partial<IProblemDetailsError>> => {
  try {
    const errorFromJson = await getResponseError(e);
    if (errorFromJson.title) {
      return errorFromJson;
    }

    return e;
  } catch (_: any) {
    return {};
  }
};

const getResponseError = async (
  e: any,
): Promise<Partial<IProblemDetailsError>> => {
  try {
    return e.responseJSON || {};
  } catch (e: any) {
    console.info(e);
    return {};
  }
};

export default getResponseError;
